import React from 'react';
import ContainerTemplate from '../../widgets/template/Container';
import VerificadorView from './VerificadorView';
import * as ROUTES from '../../router/Routes';

const VerificadorModule = () => {
  return (
    <ContainerTemplate active={ROUTES.verificador} routes={[]}>
      <VerificadorView />
    </ContainerTemplate>
  );
};

export default VerificadorModule;
